var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.activeName === "1" ? _vm.rules : {},
          },
        },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SettingOrderSourceDeploy.tab1"),
                    name: "1",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingOrderSourceDeploy.sourcing"),
                        prop: "value1",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.onChange },
                          model: {
                            value: _vm.form.value1,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "value1", $$v)
                            },
                            expression: "form.value1",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SettingOrderSourceDeploy.stockOut")
                              )
                            ),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SettingOrderSourceDeploy.reSource")
                              )
                            ),
                          ]),
                          _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v(
                              _vm._s(_vm.$t("SettingOrderSourceDeploy.manual"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.value1 === 2
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SettingOrderSourceDeploy.resourceInterval"
                              ),
                              prop: "interval",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: _vm.$t("chooseText") },
                                model: {
                                  value: _vm.form.interval,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "interval", $$v)
                                  },
                                  expression: "form.interval",
                                },
                              },
                              _vm._l(_vm.options, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SettingOrderSourceDeploy.resources"
                              ),
                              prop: "value2",
                            },
                          },
                          [
                            _c(
                              "BjInputNumber",
                              {
                                attrs: { width: "180px" },
                                model: {
                                  value: _vm.form.value2,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "value2", $$v)
                                  },
                                  expression: "form.value2",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SettingOrderSourceDeploy.secondRate"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SettingOrderSourceDeploy.resourcesFail"
                              ),
                              prop: "value3",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.value3,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "value3", $$v)
                                  },
                                  expression: "form.value3",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SettingOrderSourceDeploy.stockOut"
                                      )
                                    )
                                  ),
                                ]),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SettingOrderSourceDeploy.manual")
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SettingOrderSourceDeploy.tab2"),
                    name: "2",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingOrderSourceDeploy.tabTitle"),
                        prop: "value",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "value", $$v)
                          },
                          expression: "form.value",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName:
                        "v-permission:SettingOrderSourceDeployConfig_Save",
                      arg: "SettingOrderSourceDeployConfig_Save",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }